import React, { Component, Fragment } from 'react';

export default class PhoneFlip extends Component {

	render() {
		
	    return (
	    	<div id="phone-intro">
				<div className="phone-intro-content">
					<img src="https://static.cdn.gallerymediagroup.com/citi20in20/logos/20-in-20-logo.svg" />
					<div>
						<img src="https://static.cdn.gallerymediagroup.com/citi20in20/icons/flip-icon.svg" />
						<p>Please turn your device to begin the viewing experience</p>
					</div>
				</div>
			</div>
	    );
	}
}